import _ from 'underscore'
import { mapGetters, mapState } from 'vuex'
import { dynamicMapState } from '@/common/util/store'

export const ClearMixin = {
  computed: {
    ...mapState(['dna', 'clearOnError']),
    ...mapGetters(['isIphone', 'isIpad']),
    ...dynamicMapState('context.namespace', ['forcedFieldClear', 'fieldClear'])
  },
  data() {
    return {
      clearFromMixin: false
    }
  },
  watch: {
    forcedFieldClear(newVal) {
      if (newVal) {
        this.clear()
      }
    },
    fieldClear(newVal) {
      // We check if this field is configured to be cleaned. If not
      // this action should be ignored
      if (!newVal || !this.dna || this.clearOnError === false) return

      // HACK: If any brand is configured to be cleaned, we clean it
      // Should come correctly configured in the DNA
      for (const brand in this.dna.cards) {
        const brandConfig = this.dna.cards[brand].fields[this.fieldName]
        if (brandConfig.clearOnError === true) {
          this.clear()
          break
        }
      }
    }
  },
  methods: {
    clear() {
      if (this.isDisabled) return
      if (this.isIphone || this.isIpad) this.$store.dispatch('lockFakeCursor')
      this.clearFromMixin = true
    }
  }
}
